import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/src/frontend/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/vsts/work/1/s/src/frontend/features/theme/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/home/vsts/work/1/s/src/frontend/features/ui/toaster.tsx");
